module.exports = __webpack_public_path__ + "img/bsu-logo.a4c73ff6.png";